export const mobileDefinitionTextStyle = {
  fontSize: 'clamp(17px, 3.2vmin, 22px)',
  lineHeight: 1.18,
};
